// extracted by mini-css-extract-plugin
export default {"unhandled-error":"UnhandledError_unhandled-error__5v6dY","unhandled-error__message":"UnhandledError_unhandled-error__message__w4Swu"};